<template>
  <!-- BEGIN: Content-->
  <div class="app-content content ">
    <div class="content-overlay"></div>
    <div class="header-navbar-shadow"></div>
    <div class="content-wrapper">
      <div class="content-header row">
        <div class="content-header-left col-md-9 col-12 mb-2">
          <Breadcrumb
              name="Merchant"
              bc1="App"
              bc2="Merchant"
              bc3="Groups"
          ></Breadcrumb>
        </div>
      </div>
      <div class="content-body">
        <!-- Basic Horizontal form layout section start -->
        <section id="basic-horizontal-layouts">
          <div class="row">
            <div class="col-md-12 col-12">
              <div class="card">
                <div class="card-header">
                  <h4 class="card-title">Assign Groups To Merchant</h4>
                </div>
                <div class="card-body">
                  <Form class="form form-horizontal">
                    <div class="row">
                      <h6 class="section-label mx-1 mb-2">Groups</h6>
                      <div class="col-12 mb-2" >
                        <div class="custom-control custom-switch mb-1" v-for="(feature,index) in featureList" :key="index">
                          <input :id="index" type="checkbox" v-if="typeof(feature.checked) != 'undefined'"
                                 class="custom-control-input" v-model="feature.checked" />
                          <label :class="typeof(feature.checked) != 'undefined' ? 'custom-control-label':''" :for="index">
                            {{ feature.name }}
                          </label>
                        </div>
                      </div>
                      <div class="col-sm-9 d-flex pb-2 px-2">
                        <button
                            type="button"
                            class="btn btn-primary mr-1 d-flex "
                            @click="sendCall"
                            :disabled="loading"
                        >
                          <Loader :loading="loading" :size="size"></Loader>
                          Save Changes
                        </button>
                        <button
                            type="button"
                            class="btn btn-gradient-secondary"
                            @click="$router.push({ name: 'merchants' })"
                        >
                          Back
                        </button>
                      </div>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </section>
        <!-- Basic Horizontal form layout section end -->
      </div>
    </div>
  </div>
  <!-- END: Content-->
</template>

<script>
export default {
  mounted() {
    this.getAllRoles()


  },
  data() {
    return {
      loader: false,
      featureList: [],
      tmpLIst:[],
      alreadyCheckedRoles: {},
      loading: false,
      size: "10px",

    }
  },
  methods: {
    sendCall() {

      this.$validator.validateAll().then(valid => {
        if (valid) {

          this.loading = true;
          let rolesId = []
          //extracting ids to send with the request
          this.featureList.forEach(eachFeature => {
            if (eachFeature.checked) {
              rolesId.push(eachFeature.id)
            }
          })


          let data = {
            roleId : JSON.stringify(rolesId),
            userId : this.$route.params.id,
          }
          this.makeRequest("post", "v1/manage-admin-user-role", data).then(
              callResponse => {
                this.loading = false;
                if (!callResponse.error) {
                  let code = callResponse.response.data.code;
                  if (code == 200) {
                    this.$router.push({
                      name: "merchants",
                    });
                  }
                }
              }
          );
        }
      });


    },
    getAllRoles() {
      let type = [3];
      let requestData = {
        flag: "all",
        type: JSON.stringify(type)
      }
      this.makeRequest('post', 'v1/get-role', requestData, {}, false).then(callResponse => {

        if (!callResponse.error) {
          let code = callResponse.response.data.code;

          if (code == 200) {
            this.tmpLIst = callResponse.response.data.data
            this.getAlreadySelectedRoles()
          }
        }

      });
    },
    getAlreadySelectedRoles() {
      this.makeRequest("post", "v1/detail-merchant", {
        id: this.$route.params.id
      }, {}, false).then(callResponse => {
        if (!callResponse.error) {
          let code = callResponse.response.data.code;
          if (code == 200) {
            let data = callResponse.response.data.data.user_roles
            data.forEach(v => {
              this.alreadyCheckedRoles[v.role_id] = true
            })

            this.tmpLIst.forEach(eachFeature => {
              if (typeof (this.alreadyCheckedRoles[eachFeature.id]) != 'undefined') {
                eachFeature.checked = true
              } else {
                eachFeature.checked = false
              }

            })
            this.featureList = this.tmpLIst

          }
        }
      });
    },
  },
}
</script>

